import { API_URL } from '../../../api';
import { axios } from '../../../plugins/axios';
import { stripFrameLocations } from './strip-frame-locations';
const MAX_FIELD_LENGTH = 8000;
const truncate = (value) => (value !== null && value !== void 0 ? value : '').slice(0, MAX_FIELD_LENGTH);
const recentlyReportedErrors = new Set();
const normalizeError = (error) => {
    if (error instanceof Error) {
        return error;
    }
    try {
        if (typeof error === 'object' && error !== null) {
            const message = Reflect.get(error, 'message');
            const stack = Reflect.get(error, 'stack');
            if (typeof message === 'string') {
                const normalizedError = new Error(message);
                if (typeof stack === 'string') {
                    normalizedError.stack = stack;
                }
                return normalizedError;
            }
        }
        return new Error(String(error));
    }
    catch (_a) {
        return new Error('Unknown non-Error value thrown by React');
    }
};
export const reportCrash = ({ app, error, kind, componentStack, }) => {
    try {
        if (recentlyReportedErrors.has(error)) {
            return;
        }
        recentlyReportedErrors.add(error);
        queueMicrotask(() => recentlyReportedErrors.delete(error));
        const normalizedError = normalizeError(error);
        const payload = {
            app,
            kind,
            message: truncate(normalizedError.message),
            stack: truncate(stripFrameLocations(normalizedError.stack)),
            componentStack: truncate(stripFrameLocations(componentStack)),
            url: typeof window !== 'undefined'
                ? `${window.location.origin}${window.location.pathname}`
                : '',
            userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
            timestamp: Date.now(),
        };
        void axios
            .post(`${API_URL}/telemetry/crash-report`, payload, { timeout: 5000 })
            .catch(() => undefined);
    }
    catch (_a) {
    }
};
